import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';

const experiences = [
  {
    company: 'PT. Digital Daya Teknologi',
    role: 'Quality Assurance Engineer',
    period: 'Jun 2023 - Present',
    current: true,
  },
  {
    company: 'PT. Bank KEB Hana Indonesia',
    role: 'Production Support',
    period: 'Jan 2022 - Sep 2023',
  },
  {
    company: 'PT. Bank KEB Hana Indonesia',
    role: 'Quality Assurance (Manual)',
    period: 'Mar 2021 - Dec 2021',
  },
  {
    company: 'PT. Bank KEB Hana Indonesia',
    role: 'Front End Developer',
    period: 'Mar 2020 - Feb 2021',
  },
  {
    company: 'PT. Bank KEB Hana Indonesia',
    role: 'Business Analyst (Internship)',
    period: 'Oct 2019 - Feb 2020',
  },
  {
    company: 'PT. Transcosmos Indonesia',
    role: 'Quality Assurance (Manual) (Internship)',
    period: 'Mar 2018 - Feb 2019',
    location: 'Central Jakarta, ID',
  },
];

export const About = () => {
  return (
    <section
      id="about"
      className="min-h-screen py-24 sm:py-32"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-white mb-4"
            style={{ fontFamily: 'Outfit' }}
            data-testid="about-heading"
          >
            Working Experience
          </h2>
          <p className="text-base leading-relaxed text-slate-300" style={{ fontFamily: 'IBM Plex Sans' }}>
            This diverse experience has given me a comprehensive understanding of the software development lifecycle and enables me to deliver high-quality software from both technical and business perspectives.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="bg-slate-900/30 border border-white/5 p-8 hover:border-white/10 transition-all duration-300 ease-out"
              data-testid={`experience-card-${index}`}
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-12 h-12 bg-emerald-600/10 border border-emerald-500/20 rounded-sm flex items-center justify-center">
                    <Briefcase className="w-5 h-5 text-emerald-500" />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3
                        className="text-xl font-medium text-white mb-1"
                        style={{ fontFamily: 'Outfit' }}
                        data-testid={`experience-role-${index}`}
                      >
                        {exp.role}
                      </h3>
                      <p className="text-slate-400" style={{ fontFamily: 'IBM Plex Sans' }}>
                        {exp.company}
                      </p>
                    </div>
                    {exp.current && (
                      <span className="px-3 py-1 bg-emerald-600/10 border border-emerald-500/20 text-emerald-400 text-xs rounded-sm">
                        Current
                      </span>
                    )}
                  </div>
                  <p
                    className="text-sm text-slate-400 font-mono"
                    style={{ fontFamily: 'JetBrains Mono' }}
                    data-testid={`experience-period-${index}`}
                  >
                    {exp.period}
                  </p>
                  {exp.location && (
                    <p className="text-sm text-slate-500 mt-2">{exp.location}</p>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
